// extracted by mini-css-extract-plugin
export var layoutContainer = "_bh-0";
export var layoutContainerNoRounding = "_bh-6";
export var layoutContainerOpen = "_bh-5";
export var layoutContainerResizing = "_bh-1";
export var mainContent = "_bh-2";
export var resizeDivider = "_bh-3";
export var slidePanel = "_bh-4";